<!-- <yt-fw-default-update-buttons (SaveItemClicked)="Save()" (CloseItemClicked)="Close()" (AddItemClicked)="AddItem()"></yt-fw-default-update-buttons> -->
<yt-fw-default-update-buttons #defaultUpdateButtons>
    <div class="btn-group mr-2" >
        <button class="btn btn-outline-primary" type="button" (click)="UcitajPoljeZaNapomenu()" container="body">
            <i class="fas fa-file-alt"></i>
            <span style="padding-left: 5px;" translate="USER.NAPOMENA.SINGULAR"></span>
        </button>
    </div>
</yt-fw-default-update-buttons>
<yt-user-update #baseUpdate></yt-user-update>
